import {Action} from "@ngrx/store";

export const LOAD_USER_PAYMENT_METHODS: string = '[user payment methods] Load User Payment Methods';
export const LOAD_USER_PAYMENT_METHODS_SUCCESS: string = '[user payment methods] Load User Payment Methods Success';
export const LOAD_USER_PAYMENT_METHODS_FAIL: string = '[user payment methods] Load User Payment Methods Fail';



export class LoadUserPaymentMethods implements Action {

  readonly type: string = LOAD_USER_PAYMENT_METHODS;

}

export class LoadUserPaymentMethodsSuccess implements Action {

  readonly type: string = LOAD_USER_PAYMENT_METHODS_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadUserPaymentMethodsFail implements Action {

  readonly type: string = LOAD_USER_PAYMENT_METHODS_FAIL;
  constructor(public payload: string) {}

}

export type UserPaymentMethodsAction = LoadUserPaymentMethods | LoadUserPaymentMethodsSuccess | LoadUserPaymentMethodsFail;
